import React, { useState } from 'react';
import { Flex, Link, Modal, Title } from '@gjensidige/builders-components';

import styles from '../../style.module.scss';
import { MoreInfoModalProps } from '../../Types';

export const MoreInfoModal: React.FC<MoreInfoModalProps> = ({
  linkText,
  title,
  content,
  closeLabel,
  ariaLabel,
  wrapperClassName,
  ariaDescribedBy
}: MoreInfoModalProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className={styles.moreInfoWrapper}>
      <Link href="#" onClick={() => setIsOpen(true)} id={ariaDescribedBy}>
        {linkText}
      </Link>
      <Modal
        open={isOpen}
        closeLabel={closeLabel}
        onClose={() => setIsOpen(false)}
        aria-label={ariaLabel}
      >
        <div className={wrapperClassName}>
          <Title as="h2" size="4" className={styles.moreInfoModalHeader}>
            {title}
          </Title>
          <Flex>{content}</Flex>
        </div>
      </Modal>
    </div>
  );
};
